import React, { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import config from '../../../configs/config';
import { getLanguageSection, toggleSiteLanguage } from '../../../shared/services/languageService';
import { NavLink, useLocation } from 'react-router-dom';
import ReservHotelContactModal from "./ContactModal";

// El estado activo se calcula a mano en vez de usar activeClassName de NavLink:
// el `to` de estos links lleva query string (?iscanada=-1) y NavLink de React
// Router 5 la toma como parte de la ruta a comparar, así que nunca haría match.
// Se compara por sufijo porque config.basename cambia según el dominio.
function matchesRoute(pathname, route) {
  const normalized = pathname.replace(/\/+$/, "");
  return normalized === route || normalized.endsWith(route);
}

// Register y Login comparten forma de pastilla para que el activo se vea igual
// en los dos. Solo uno puede estar resaltado a la vez: el que no corresponde a
// la ruta actual cae a `PILL_MUTED`.
const PILL_BASE = "inline-flex min-h-[34px] items-center whitespace-nowrap rounded-md px-3 text-base leading-none";
const PILL_ACTIVE = "bg-[#4f9ac4] font-bold text-white shadow-[0_6px_14px_rgba(79,154,196,0.35)] ring-2 ring-[#4f9ac4]/40";
const PILL_MUTED = "bg-transparent font-normal text-[#111111] hover:text-[#4f9ac4]";
// Login sigue siendo el CTA azul mientras no estemos en login ni en registro.
const PILL_CTA = "bg-[#4f9ac4] font-normal text-white hover:bg-[#438eb8]";

function createInitialState() {
  return {
    homePage: Cookies.get('language') === "esp" ? "https://marivalagents.com/es/" : "https://marivalagents.com/es/",
    blogPage: Cookies.get('language') === "esp" ? "https://marivalagents.com/blog" : "https://marivalagents.com/blog",
    rewardsPage: Cookies.get('language') === "esp" ? "https://marivalagents.com/es/programa-rewards" : "https://marivalagents.com/rewards-program",
    agentPage: "",
    agencyPage: "",
    contactusPage: Cookies.get('language') === "esp" ? "https://marivalrewards.com/es/contactus.html" : "https://marivalrewards.com/contactus.html",
    loginPage: "",
  };
}

function NavigationPublic() {
  const [pages, setPages] = useState(createInitialState);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const language = getLanguageSection('navigationpublic');


   const [isContactModalOpen, setIsContactModalOpen] = useState(false);
   const currentLanguage = Cookies.get("language");
   const isSpanish = currentLanguage === "esp";

  const { pathname } = useLocation();
  const isRegisterPage = matchesRoute(pathname, "/agentregister");
  const isLoginPage = matchesRoute(pathname, "/login");

  useEffect(() => {
    if (Cookies.get('iscanada') === -1) {
      setPages({
        homePage: Cookies.get('language') === "esp" ? "https://marivalagents.com/es/" : "https://marivalrewards.ca/",
        blogPage: Cookies.get('language') === "esp" ? "https://marivalagents.com/blog" : "https://marivalagents.com/blog",
        rewardsPage: Cookies.get('language') === "esp" ? "https://marivalrewards.ca/es/rewards_program.html" : "https://marivalrewards.ca/rewards_program.html",
        agentPage: "?iscanada=-1",
        agencyPage: "?iscanada=-1",
        contactusPage: Cookies.get('language') === "esp" ? "https://marivalrewards.ca/es/contactus.html" : "https://marivalrewards.ca/contactus.html",
        loginPage: "?iscanada=-1"
      });
    }
  }, []);

  const selectlanguage = (event) => {
    event.preventDefault();
    toggleSiteLanguage();
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((current) => !current);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="mr-ui">
      <header id="marivalMenu" className="fixed left-0 right-0 top-0 z-[1000] border-b border-slate-200 bg-white shadow-[0_2px_8px_rgba(17,24,63,0.10)]">
        <div className="mx-auto flex min-h-[82px] w-full max-w-[1311px] items-center justify-between gap-5 px-5 py-0 md:min-h-[99px] md:px-8">
          <a href={pages.homePage} className="flex shrink-0 items-center">
            <img
              src={config.publicurl + "assets/logo/marival-agents.svg"}
              alt="Marival Resorts for Agents"
              className="w-[180px] md:w-[250px]"
            />
          </a>

          <div className="hidden items-center gap-5 md:flex">
            <nav className="flex items-center gap-6">
              <a className="whitespace-nowrap text-base font-normal leading-none text-[#111111] hover:text-[#4f9ac4]" href={pages.blogPage}>Blog</a>
              
              <a className="cursor-pointer whitespace-nowrap text-base font-normal leading-none text-[#111111] hover:text-[#4f9ac4]" onClick={() => setIsContactModalOpen(true)}>
                Contact Us
              </a>
              <NavLink
                className={PILL_BASE + " " + (isRegisterPage ? PILL_ACTIVE : PILL_MUTED)}
                to={"/agentregister" + pages.agentPage}
                aria-current={isRegisterPage ? "page" : undefined}
              >
                Register
              </NavLink>
            </nav>

            <NavLink
              className={
                PILL_BASE +
                " " +
                (isLoginPage ? PILL_ACTIVE : isRegisterPage ? PILL_MUTED : PILL_CTA)
              }
              to={"/login" + pages.loginPage}
              aria-current={isLoginPage ? "page" : undefined}
            >
              Login
            </NavLink>


            <span className="h-4 w-px bg-[#111111]" aria-hidden="true"></span>

            <a
              className="flex items-center gap-1.5 whitespace-nowrap text-base font-bold leading-none text-[#111111] hover:text-[#4f9ac4]"
              href="/"
              onClick={selectlanguage}
            >
              <img
                src={config.publicurl + "assets/icons/globe.svg"}
                alt=""
                className="h-4 w-4 opacity-70"
              />
              <span>{language.lang}</span>
            </a>
          </div>

          <button
            type="button"
            className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-slate-200 bg-white text-[#071a4a] shadow-sm md:hidden"
            aria-label="Open navigation menu"
            aria-expanded={isMobileMenuOpen}
            onClick={toggleMobileMenu}
          >
            {isMobileMenuOpen ? (
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            )}
          </button>
        </div>

        <div className={(isMobileMenuOpen ? "block" : "hidden") + " border-t border-slate-100 bg-white px-5 py-4 md:hidden"}>
          <nav className="mx-auto grid max-w-[1311px] gap-2 text-center">
            <a className="rounded-md bg-slate-50 px-3 py-3 text-sm font-bold text-[#111111]" href={pages.blogPage} onClick={closeMobileMenu}>Blog</a>
            <a className="rounded-md bg-slate-50 px-3 py-3 text-sm font-bold text-[#111111]" href={pages.rewardsPage} onClick={closeMobileMenu}>Marival Rewards</a>
            <a className="rounded-md bg-slate-50 px-3 py-3 text-sm font-bold text-[#111111]" href={pages.contactusPage} onClick={closeMobileMenu}>Contact Us</a>
            <NavLink
              className={
                "rounded-md px-3 py-3 text-sm font-bold " +
                (isRegisterPage ? "bg-[#4f9ac4] text-white" : "bg-slate-50 text-[#111111]")
              }
              to={"/agentregister" + pages.agentPage}
              onClick={closeMobileMenu}
              aria-current={isRegisterPage ? "page" : undefined}
            >
              Register
            </NavLink>
            <NavLink
              className={
                "rounded-md px-3 py-3 text-sm font-bold " +
                (isLoginPage
                  ? "bg-[#4f9ac4] text-white"
                  : isRegisterPage
                  ? "bg-slate-50 text-[#111111]"
                  : "bg-[#4f9ac4] text-white")
              }
              to={"/login" + pages.loginPage}
              onClick={closeMobileMenu}
              aria-current={isLoginPage ? "page" : undefined}
            >
              Login
            </NavLink>
            <a className="rounded-md bg-slate-50 px-3 py-3 text-sm font-bold text-[#111111]" href="/" onClick={selectlanguage}>
              {language.lang}
            </a>
          </nav>
        </div>
      </header>


      <ReservHotelContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        title={isSpanish ? "Contacto" : "Contact"}
      />
    </div>
  );
}

export default NavigationPublic;
